import React from "react";

interface IconProps {
  className?: string;
}

export const AllergyIcon: React.FC<IconProps> = ({ className = "size-4" }) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Allergy"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1552 17.9884C13.1554 18.3566 12.8572 18.6553 12.489 18.6556C12.1208 18.6559 11.8221 18.3577 11.8218 17.9895C11.8215 17.6213 12.1197 17.3226 12.4879 17.3223C12.8561 17.322 13.1548 17.6202 13.1552 17.9884ZM16.489 18.6523C16.4893 19.0205 16.1911 19.3193 15.8229 19.3195C15.4547 19.3199 15.156 19.0216 15.1557 18.6535C15.1554 18.2853 15.4536 17.9865 15.8218 17.9862C16.19 17.9859 16.4887 18.2841 16.489 18.6523ZM13.8251 21.9879C14.1932 21.9875 14.4915 21.6889 14.4912 21.3207C14.4909 20.9525 14.1922 20.6542 13.824 20.6545C13.4558 20.6549 13.1576 20.9535 13.1578 21.3217C13.1582 21.6899 13.4569 21.9882 13.8251 21.9879ZM17.824 20.6513C17.8243 21.0195 17.526 21.3182 17.1578 21.3185C16.7897 21.3188 16.491 21.0205 16.4906 20.6523C16.4904 20.2841 16.7886 19.9855 17.1568 19.9851C17.525 19.9849 17.8237 20.2831 17.824 20.6513ZM18.4934 23.9841C18.8616 23.9837 19.1598 23.685 19.1595 23.3168C19.1592 22.9487 18.8605 22.6504 18.4923 22.6507C18.1241 22.651 17.8258 22.9497 17.8262 23.3179C17.8265 23.6861 18.1252 23.9843 18.4934 23.9841ZM20.4906 20.6491C20.491 21.0173 20.1927 21.316 19.8245 21.3163C19.4564 21.3166 19.1576 21.0183 19.1573 20.6501C19.157 20.282 19.4552 19.9833 19.8234 19.9829C20.1916 19.9827 20.4904 20.2809 20.4906 20.6491ZM15.1606 24.6535C15.5288 24.6531 15.827 24.3544 15.8267 23.9862C15.8264 23.6181 15.5277 23.3198 15.1595 23.3201C14.7913 23.3204 14.4931 23.6191 14.4934 23.9873C14.4937 24.3555 14.7924 24.6537 15.1606 24.6535ZM12.4928 23.3223C12.4932 23.6905 12.1949 23.9892 11.8267 23.9895C11.4585 23.9898 11.1598 23.6916 11.1595 23.3234C11.1592 22.9552 11.4574 22.6565 11.8256 22.6562C12.1938 22.6559 12.4926 22.9541 12.4928 23.3223ZM10.4912 21.3239C10.8594 21.3236 11.1576 21.0249 11.1573 20.6567C11.157 20.2885 10.8583 19.9903 10.4901 19.9906C10.1219 19.9909 9.82371 20.2896 9.82397 20.6578C9.82431 21.026 10.123 21.3242 10.4912 21.3239Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 4.00008C16.0523 4.00008 16.5 4.44779 16.5 5.00008V15.3334H17.8333V7.00008C17.8333 6.44779 18.2811 6.00008 18.8333 6.00008C19.3856 6.00008 19.8333 6.44779 19.8333 7.00008V17.3904C19.8333 18.6599 21.4397 19.2111 22.2191 18.2089L24.3435 15.4777C24.7532 14.9509 25.5517 14.9579 25.9521 15.4918C26.2002 15.8226 26.2221 16.271 26.0075 16.6245L21.2049 24.5329C19.8975 26.6856 17.5614 28.0001 15.0427 28.0001C11.0611 28.0001 7.83333 24.7723 7.83333 20.7907V11.0001C7.83333 10.4478 8.28107 10.0001 8.83333 10.0001C9.3856 10.0001 9.83333 10.4478 9.83333 11.0001V16.7451H11.1667V7.00008C11.1667 6.44779 11.6144 6.00008 12.1667 6.00008C12.7189 6.00008 13.1667 6.44779 13.1667 7.00008V15.3334H14.5V5.00008C14.5 4.44779 14.9477 4.00008 15.5 4.00008ZM13.1691 4.89245C13.2253 3.65375 14.2474 2.66675 15.5 2.66675C16.7526 2.66675 17.7747 3.65375 17.8309 4.89245C18.1346 4.74775 18.4745 4.66675 18.8333 4.66675C20.122 4.66675 21.1667 5.71141 21.1667 7.00008V17.3904L23.291 14.6591C24.2405 13.4383 26.0909 13.4545 27.0188 14.6918C27.5937 15.4583 27.6445 16.4975 27.1471 17.3165L22.3445 25.2249C20.7953 27.7759 18.0272 29.3334 15.0427 29.3334C10.3247 29.3334 6.5 25.5087 6.5 20.7907V11.0001C6.5 9.71141 7.54467 8.66675 8.83333 8.66675C9.1912 8.66675 9.53027 8.74728 9.83333 8.89128V7.00008C9.83333 5.71141 10.878 4.66675 12.1667 4.66675C12.5255 4.66675 12.8654 4.74775 13.1691 4.89245Z"
      fill="currentColor"
    />
  </svg>
);

export const ChillIcon: React.FC<IconProps> = ({ className = "size-4" }) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Chill"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8334 6.00008C19.8334 7.84101 18.341 9.33341 16.5001 9.33341C14.6591 9.33341 13.1667 7.84101 13.1667 6.00008C13.1667 4.15913 14.6591 2.66675 16.5001 2.66675C18.341 2.66675 19.8334 4.15913 19.8334 6.00008ZM18.5001 6.00008C18.5001 7.10468 17.6047 8.00008 16.5001 8.00008C15.3955 8.00008 14.5001 7.10468 14.5001 6.00008C14.5001 4.89551 15.3955 4.00008 16.5001 4.00008C17.6047 4.00008 18.5001 4.89551 18.5001 6.00008Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16659 10.6667C8.54645 10.6667 8.00592 11.0036 7.64759 11.362C7.30105 11.7085 6.97611 12.2257 6.97611 12.762C6.97611 13.1223 7.15215 13.4094 7.28799 13.5905C7.42405 13.7719 7.59572 13.9435 7.72812 14.0758L7.74279 14.0905C7.84299 14.1907 7.92332 14.2719 7.98745 14.3436C7.87125 14.4011 7.73392 14.4603 7.57105 14.5307L7.57038 14.531C7.50912 14.5574 7.44425 14.5854 7.37559 14.6155C7.093 14.7391 6.74458 14.8984 6.46428 15.1027C6.19737 15.2974 5.83325 15.6493 5.83325 16.1905C5.83325 16.6373 6.04453 16.9631 6.28205 17.1858C6.48507 17.3761 6.73739 17.5178 6.91003 17.6147L6.93499 17.6287C7.14337 17.7459 7.25699 17.8141 7.32965 17.8823C7.34399 17.8957 7.35239 17.9053 7.35699 17.9113C7.35492 18.0179 7.29845 18.1159 6.98089 18.4334L6.94223 18.4719C6.68326 18.7287 6.21421 19.1939 6.21421 19.9048C6.21421 20.377 6.47531 20.7351 6.71309 20.967C6.95725 21.2051 7.25879 21.3919 7.52339 21.5308C7.79379 21.6728 8.05919 21.7819 8.25392 21.8549C8.35219 21.8918 8.43472 21.9203 8.49365 21.9399C8.52319 21.9497 8.54692 21.9573 8.56392 21.9627L8.58439 21.969L8.59059 21.9709L8.59265 21.9715L8.59405 21.9719L9.23265 22.1635L9.61572 20.8864L8.97719 20.6949L8.97599 20.6945L8.96452 20.6909C8.95365 20.6875 8.93652 20.682 8.91392 20.6745C8.86872 20.6595 8.80239 20.6366 8.72212 20.6065C8.55972 20.5456 8.34892 20.4583 8.14312 20.3503C7.93152 20.2392 7.75685 20.1225 7.64392 20.0123C7.57539 19.9455 7.55379 19.9056 7.54779 19.892C7.55205 19.7877 7.61252 19.6875 7.92372 19.3763L7.96239 19.3378C8.22132 19.0809 8.69039 18.6157 8.69039 17.9048C8.69039 17.4581 8.47912 17.1322 8.24159 16.9095C8.03859 16.7192 7.78625 16.5775 7.61365 16.4807L7.58865 16.4667C7.38605 16.3527 7.27305 16.2851 7.20012 16.2188C7.21339 16.2077 7.22979 16.1947 7.24985 16.1801C7.39812 16.072 7.62112 15.9634 7.90999 15.837C7.95819 15.8159 8.00919 15.794 8.06199 15.7713C8.28972 15.6732 8.55025 15.5611 8.75532 15.4457C8.88419 15.3732 9.03732 15.2751 9.16499 15.1439C9.29392 15.0116 9.45232 14.7867 9.45232 14.4763C9.45232 14.1159 9.27625 13.8289 9.14039 13.6477C9.00439 13.4663 8.83265 13.2947 8.70032 13.1624L8.68559 13.1477C8.53405 12.9961 8.42785 12.8881 8.35465 12.7905C8.33525 12.7647 8.32272 12.7453 8.31479 12.7319C8.31565 12.7281 8.31679 12.7241 8.31799 12.7197C8.32645 12.6901 8.34139 12.6511 8.36559 12.6045C8.41459 12.5101 8.49125 12.4039 8.59039 12.3048C8.80345 12.0917 9.02479 12.0001 9.16659 12.0001H9.83325V10.6667H9.16659ZM8.59405 21.9719L8.76525 21.4013L8.61625 21.8983C8.60792 21.9259 8.60279 21.9432 8.59952 21.954C8.59412 21.972 8.59412 21.9719 8.59405 21.9719Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0098 10.6667C12.1225 10.6667 11.3414 11.2513 11.0911 12.1024L9.9146 16.1024C9.63014 17.0696 10.11 18.0973 11.0341 18.5001L11.8333 18.8485V21.1484V21.1556V27.5112C11.8333 28.5683 12.7641 29.2931 13.7467 29.3317C14.7267 29.3702 15.7149 28.7272 15.8242 27.6853L16.4205 22.0001H16.5794L17.1757 27.6853C17.2851 28.7272 18.2732 29.3702 19.2533 29.3317C20.2359 29.2931 21.1667 28.5683 21.1667 27.5112V21.3393V21.3334V18.8485L21.9658 18.5001C22.89 18.0973 23.3699 17.0696 23.0854 16.1024L21.9089 12.1024C21.6585 11.2513 20.8774 10.6667 19.9902 10.6667H13.0098ZM19.5998 19.3077C19.6773 19.2856 19.7553 19.2611 19.8333 19.235V21.3275V21.3334V27.5112C19.8333 27.6897 19.6426 27.982 19.2009 27.9994C18.7566 28.0169 18.5216 27.7349 18.5018 27.5462L17.8428 21.2639C17.8072 20.9245 17.5211 20.6667 17.1798 20.6667H15.8201C15.4789 20.6667 15.1927 20.9245 15.1571 21.2639L14.4981 27.5462C14.4783 27.7349 14.2433 28.0169 13.7991 27.9994C13.3574 27.982 13.1667 27.6897 13.1667 27.5112V21.1556V21.1532V19.235C13.2447 19.2611 13.3227 19.2856 13.4002 19.3077C13.7178 19.3985 14.1127 19.4767 14.4893 19.4049C14.6899 19.3667 14.8989 19.2835 15.0822 19.1272C15.2669 18.9698 15.3914 18.7673 15.4658 18.5442C15.6331 18.0422 15.8057 17.4005 15.5259 16.771C15.2481 16.1459 14.6163 15.7286 13.7476 15.3811L13.1286 15.1335L12.6334 16.3715L13.2524 16.6191C14.0503 16.9382 14.2519 17.1875 14.3075 17.3125C14.3601 17.431 14.3667 17.6185 14.2087 18.0989C14.135 18.1039 13.9945 18.0909 13.7665 18.0257C13.5156 17.9541 13.235 17.8428 12.932 17.7174L12.802 17.6634C12.5505 17.5587 12.2815 17.4467 12.0441 17.3676L11.4117 17.1568L11.4048 17.1775C11.2063 17.0111 11.1173 16.7383 11.1937 16.4786L12.3702 12.4786C12.4537 12.1949 12.7141 12.0001 13.0098 12.0001H19.9902C20.2859 12.0001 20.5463 12.1949 20.6297 12.4786L21.8062 16.4786C21.8826 16.7383 21.7937 17.0111 21.5952 17.1775L21.5883 17.1568L20.9559 17.3676C20.7185 17.4467 20.4495 17.5587 20.198 17.6634L20.068 17.7174C19.765 17.8428 19.4844 17.9541 19.2335 18.0257C19.0055 18.0909 18.865 18.1039 18.7913 18.0989C18.6333 17.6185 18.6399 17.431 18.6925 17.3125C18.7481 17.1875 18.9497 16.9382 19.7476 16.6191L20.3666 16.3715L19.8714 15.1335L19.2524 15.3811C18.3837 15.7286 17.7519 16.1459 17.4741 16.771C17.1943 17.4005 17.3669 18.0422 17.5342 18.5442C17.6086 18.7673 17.7331 18.9698 17.9178 19.1272C18.1011 19.2835 18.3101 19.3667 18.5107 19.4049C18.8873 19.4767 19.2822 19.3985 19.5998 19.3077Z"
      fill="currentColor"
    />
    <path
      d="M25.3524 11.362C24.9941 11.0036 24.4535 10.6667 23.8334 10.6667H23.1667V12.0001H23.8334C23.9752 12.0001 24.1965 12.0917 24.4096 12.3048C24.5087 12.4039 24.5854 12.5101 24.6344 12.6045C24.6586 12.6511 24.6735 12.6901 24.682 12.7197C24.6832 12.7241 24.6843 12.7281 24.6852 12.7319C24.6773 12.7453 24.6647 12.7647 24.6453 12.7905C24.5721 12.8881 24.4659 12.9961 24.3144 13.1477L24.2997 13.1624C24.1673 13.2947 23.9956 13.4663 23.8596 13.6477C23.7237 13.8289 23.5477 14.1159 23.5477 14.4763C23.5477 14.7867 23.7061 15.0116 23.835 15.1439C23.9627 15.2751 24.1158 15.3732 24.2447 15.4457C24.4497 15.5611 24.7103 15.6732 24.938 15.7713C24.9446 15.7741 24.9511 15.7769 24.9577 15.7797C25.0035 15.7995 25.0479 15.8186 25.09 15.837C25.3789 15.9634 25.6019 16.072 25.7501 16.1801C25.7702 16.1947 25.7866 16.2077 25.7999 16.2188C25.7269 16.2851 25.6139 16.3527 25.4113 16.4667L25.3864 16.4807C25.2137 16.5775 24.9614 16.7192 24.7584 16.9095C24.5209 17.1322 24.3096 17.4581 24.3096 17.9048C24.3096 18.6157 24.7787 19.0809 25.0376 19.3378L25.0763 19.3763C25.3875 19.6875 25.4479 19.7877 25.4522 19.892C25.4462 19.9056 25.4246 19.9455 25.3561 20.0123C25.2431 20.1225 25.0685 20.2392 24.8569 20.3503C24.6511 20.4583 24.4403 20.5456 24.2779 20.6065C24.1976 20.6366 24.1313 20.6595 24.0861 20.6745C24.0635 20.682 24.0463 20.6875 24.0355 20.6909L24.024 20.6945L24.0228 20.6949L23.3843 20.8864L23.7673 22.1635L24.4073 21.9715L24.4094 21.9709L24.4156 21.969L24.4361 21.9627C24.4531 21.9573 24.4768 21.9497 24.5063 21.9399C24.5653 21.9203 24.6477 21.8918 24.7461 21.8549C24.9408 21.7819 25.2062 21.6728 25.4766 21.5308C25.7412 21.3919 26.0427 21.2051 26.2869 20.967C26.5247 20.7351 26.7858 20.377 26.7858 19.9048C26.7858 19.1939 26.3167 18.7287 26.0577 18.4719L26.0191 18.4334C25.7015 18.1159 25.6451 18.0179 25.643 17.9113C25.6476 17.9053 25.656 17.8957 25.6703 17.8823C25.743 17.8141 25.8566 17.7459 26.065 17.6287L26.0899 17.6147C26.2626 17.5178 26.5149 17.3761 26.7179 17.1858C26.9555 16.9631 27.1667 16.6373 27.1667 16.1905C27.1667 15.6493 26.8026 15.2974 26.5357 15.1027C26.2554 14.8984 25.907 14.7391 25.6244 14.6155C25.5557 14.5854 25.4908 14.5574 25.4295 14.5309C25.2667 14.4606 25.1287 14.4011 25.0125 14.3436C25.0767 14.2719 25.157 14.1907 25.2572 14.0905L25.2719 14.0758C25.4042 13.9435 25.5759 13.7719 25.712 13.5905C25.8479 13.4094 26.0239 13.1223 26.0239 12.762C26.0239 12.2257 25.6989 11.7085 25.3524 11.362Z"
      fill="currentColor"
    />
  </svg>
);

export const StethoscopeIcon: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Stethoscope"
  >
    <path
      d="M8.50008 6.66667C9.23648 6.66667 9.83341 6.06971 9.83341 5.33333C9.83341 4.59695 9.23648 4 8.50008 4C8.00655 4 7.57568 4.26813 7.34515 4.66667H7.16675C6.06218 4.66667 5.16675 5.5621 5.16675 6.66667V12.6667H6.50008V6.66667C6.50008 6.29848 6.79856 6 7.16675 6H7.34515C7.57568 6.39853 8.00655 6.66667 8.50008 6.66667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.27355 12.6667H6.50008H5.16675C4.79856 12.6667 4.49695 12.9658 4.53037 13.3325C4.68536 15.0333 5.43053 16.6347 6.64799 17.8521C7.54075 18.7449 8.63995 19.3837 9.83341 19.722V21.3333C9.83341 22.2043 10.3901 22.9451 11.167 23.2196C11.1954 25.8646 13.3484 28 16.0001 28C18.6695 28 20.8334 25.8361 20.8334 23.1667V20.5C20.8334 19.1193 21.9527 18 23.3334 18C24.7141 18 25.8334 19.1193 25.8334 20.5V22.1138C25.0566 22.3883 24.5001 23.1292 24.5001 24C24.5001 25.1046 25.3955 26 26.5001 26C27.6047 26 28.5001 25.1046 28.5001 24C28.5001 23.1292 27.9435 22.3883 27.1667 22.1138V20.5C27.1667 18.3829 25.4505 16.6667 23.3334 16.6667C21.2163 16.6667 19.5001 18.3829 19.5001 20.5V23.1667C19.5001 25.0997 17.9331 26.6667 16.0001 26.6667C14.0847 26.6667 12.5287 25.1281 12.5005 23.2194C13.2771 22.9447 13.8334 22.204 13.8334 21.3333V19.722C15.0269 19.3837 16.1261 18.7449 17.0189 17.8521C18.2363 16.6347 18.9815 15.0333 19.1365 13.3325C19.1699 12.9658 18.8683 12.6667 18.5001 12.6667V6.66667C18.5001 5.5621 17.6047 4.66667 16.5001 4.66667H16.3217C16.0911 4.26813 15.6603 4 15.1667 4C14.4303 4 13.8334 4.59695 13.8334 5.33333C13.8334 6.06971 14.4303 6.66667 15.1667 6.66667C15.6603 6.66667 16.0911 6.39853 16.3217 6H16.5001C16.8683 6 17.1667 6.29848 17.1667 6.66667V12.6667H16.3933C16.0251 12.6667 15.7325 12.9673 15.6697 13.3301C15.5337 14.1164 15.1582 14.8478 14.5863 15.4196C13.8563 16.1497 12.866 16.5599 11.8334 16.5599C10.8009 16.5599 9.81061 16.1497 9.08048 15.4196C8.50868 14.8478 8.13308 14.1164 7.99708 13.3301C7.93435 12.9673 7.64168 12.6667 7.27355 12.6667ZM16.8871 14H17.6834C17.4343 15.0931 16.8815 16.1039 16.0761 16.9093C14.9509 18.0345 13.4247 18.6667 11.8334 18.6667C10.2421 18.6667 8.71601 18.0345 7.59081 16.9093C6.78539 16.1039 6.23259 15.0931 5.98343 14H6.77977C7.01357 14.8861 7.47848 15.7032 8.13768 16.3624C9.11788 17.3426 10.4473 17.8933 11.8334 17.8933C13.2196 17.8933 14.549 17.3426 15.5292 16.3624C16.1884 15.7032 16.6533 14.8861 16.8871 14ZM26.5001 23.3333C26.8683 23.3333 27.1667 23.6318 27.1667 24C27.1667 24.3682 26.8683 24.6667 26.5001 24.6667C26.1319 24.6667 25.8334 24.3682 25.8334 24C25.8334 23.6318 26.1319 23.3333 26.5001 23.3333ZM12.5001 20V21.3333C12.5001 21.7015 12.2016 22 11.8334 22C11.4652 22 11.1667 21.7015 11.1667 21.3333V20H12.5001Z"
      fill="currentColor"
    />
  </svg>
);

export const MedicineIcon: React.FC<IconProps> = ({ className = "size-4" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Medicine"
  >
    <path
      d="M18.5419 7.86755C18.811 7.92945 19.0793 7.76145 19.1411 7.4923C19.203 7.2232 19.035 6.95485 18.7659 6.893L15.4581 6.13255C15.189 6.07065 14.9207 6.23865 14.8588 6.5078C14.7969 6.7769 14.9649 7.04525 15.234 7.1071L18.5419 7.86755Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 11C19.2092 11 21 9.20915 21 7C21 4.79086 19.2092 3 17 3C14.7909 3 13 4.79086 13 7C13 9.20915 14.7909 11 17 11ZM17 10C18.6569 10 20 8.65685 20 7C20 5.34315 18.6569 4 17 4C15.3432 4 14 5.34315 14 7C14 8.65685 15.3432 10 17 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3891 4.62258C8.06535 3.85668 6.98265 3.77942 6.54775 4.49119L3.14641 10.0574C2.75405 10.6995 3.19274 11.5192 3.95795 11.5738L9.89115 11.9972C10.6564 12.0518 11.2131 11.3031 10.921 10.6122L8.3891 4.62258ZM7.4053 5.0065C7.40455 5.0074 7.40305 5.0093 7.40105 5.0126L4.005 10.5702C4.00598 10.5708 4.0083 10.5722 4.01096 10.5731C4.01348 10.574 4.01914 10.5757 4.02912 10.5764L9.9623 10.9997C9.9723 11.0004 9.9784 10.9997 9.9815 10.9991C9.9848 10.9985 9.9871 10.9976 9.98895 10.9967C9.99135 10.9956 9.99375 10.994 9.9959 10.9921L7.46805 5.01195C7.4671 5.0097 7.4663 5.0082 7.4658 5.00725C7.46285 5.00555 7.45385 5.0013 7.43895 5.0002C7.42245 4.99904 7.4114 5.0027 7.4078 5.00445L7.4066 5.00515L7.4053 5.0065Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6924 18.1796C19.194 17.4794 19.8437 15.6945 19.1435 14.1928C18.4433 12.6912 16.6584 12.0415 15.1568 12.7417L9.7189 15.2775C8.21725 15.9777 7.5676 17.7626 8.2678 19.2642C8.96805 20.7658 10.753 21.4155 12.2546 20.7153L17.6924 18.1796ZM10.1415 16.1838C9.1404 16.6506 8.7073 17.8406 9.1741 18.8416C9.64095 19.8427 10.8309 20.2758 11.832 19.809L14.065 18.7677L12.3747 15.1429L10.1415 16.1838ZM14.9713 18.3451L13.2809 14.7199L15.5794 13.6481C16.5805 13.1813 17.7704 13.6143 18.2372 14.6154C18.704 15.6165 18.2709 16.8065 17.2698 17.2733L14.9713 18.3451Z"
      fill="currentColor"
    />
  </svg>
);

export const HealthWorkerIcon: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    className={className}
    aria-label="Health Worker"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1667 13.3333C10.7985 13.3333 10.5 13.6317 10.5 13.9999C10.5 14.3681 10.7985 14.6666 11.1667 14.6666H15.8333C16.2015 14.6666 16.5 14.3681 16.5 13.9999C16.5 13.6317 16.2015 13.3333 15.8333 13.3333H11.1667Z"
      fill="currentColor"
    />
    <path
      d="M10.5 10.6667C10.5 10.2985 10.7985 10 11.1667 10H21.5C21.8682 10 22.1667 10.2985 22.1667 10.6667C22.1667 11.0349 21.8682 11.3333 21.5 11.3333H11.1667C10.7985 11.3333 10.5 11.0349 10.5 10.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 18.6667C10.5 18.2985 10.7985 18 11.1667 18H13.8333C14.2015 18 14.5 18.2985 14.5 18.6667V21.3333C14.5 21.7015 14.2015 22 13.8333 22H11.1667C10.7985 22 10.5 21.7015 10.5 21.3333V18.6667ZM11.8333 20.6667V19.3333H13.1667V20.6667H11.8333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1667 20.6667C20.2717 20.6667 21.1667 19.7717 21.1667 18.6667C21.1667 17.5617 20.2717 16.6667 19.1667 16.6667C18.0617 16.6667 17.1667 17.5617 17.1667 18.6667C17.1667 19.7717 18.0617 20.6667 19.1667 20.6667ZM19.1667 19.3334C19.5353 19.3334 19.8334 19.0353 19.8334 18.6667C19.8334 18.2981 19.5353 18.0001 19.1667 18.0001C18.7981 18.0001 18.5001 18.2981 18.5001 18.6667C18.5001 19.0353 18.7981 19.3334 19.1667 19.3334Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1667 23.4545C15.1667 22.0439 17.8317 21.3333 19.1667 21.3333C20.5017 21.3333 23.1667 22.0439 23.1667 23.4545V25.9999H15.1667V23.4545ZM16.5367 23.4807C16.5204 23.4967 16.5085 23.5096 16.5001 23.5195V24.6666H21.8334V23.5195C21.8249 23.5096 21.8131 23.4967 21.7968 23.4807C21.6877 23.3739 21.4765 23.2325 21.1459 23.0921C20.4793 22.8088 19.6569 22.6666 19.1667 22.6666C18.6766 22.6666 17.8541 22.8088 17.1875 23.0921C16.8569 23.2325 16.6458 23.3739 16.5367 23.4807Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8334 4.66675C11.8334 3.56218 12.7288 2.66675 13.8334 2.66675H19.1667C20.2713 2.66675 21.1667 3.56218 21.1667 4.66675H23.8334C24.938 4.66675 25.8334 5.56217 25.8334 6.66675V27.3334C25.8334 28.438 24.938 29.3334 23.8334 29.3334H9.16675C8.06215 29.3334 7.16675 28.438 7.16675 27.3334V6.66675C7.16675 5.56218 8.06215 4.66675 9.16675 4.66675H11.8334ZM19.1667 8.00008C20.2713 8.00008 21.1667 7.10468 21.1667 6.00008H23.8334C24.2016 6.00008 24.5001 6.29856 24.5001 6.66675V27.3334C24.5001 27.7016 24.2016 28.0001 23.8334 28.0001H9.16675C8.79855 28.0001 8.50008 27.7016 8.50008 27.3334V6.66675C8.50008 6.29856 8.79855 6.00008 9.16675 6.00008H11.8334C11.8334 7.10468 12.7288 8.00008 13.8334 8.00008H19.1667ZM13.8334 4.00008C13.4652 4.00008 13.1667 4.29856 13.1667 4.66675V6.00008C13.1667 6.36827 13.4652 6.66675 13.8334 6.66675H19.1667C19.5349 6.66675 19.8334 6.36827 19.8334 6.00008V4.66675C19.8334 4.29856 19.5349 4.00008 19.1667 4.00008H13.8334Z"
      fill="currentColor"
    />
  </svg>
);

export const BedAvailableUnselected: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Bed Available and unselected"
  >
    <path d="M2.5 13H3V15H2.5V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 13H2.5V15H3V13Z"
      fill="#047857"
    />
    <path d="M13 13H13.5V15H13V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13H13V15H13.5V13Z"
      fill="#047857"
    />
    <path
      d="M2 3.5C2 2.39543 2.89543 1.5 4 1.5H12C13.1046 1.5 14 2.39543 14 3.5V6.5H2V3.5Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H4C3.17157 2 2.5 2.67157 2.5 3.5V6H13.5V3.5C13.5 2.67157 12.8284 2 12 2ZM4 1.5C2.89543 1.5 2 2.39543 2 3.5V6.5H14V3.5C14 2.39543 13.1046 1.5 12 1.5H4Z"
      fill="#047857"
    />
    <path
      d="M0 11H16V13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13V11Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 11H15.5V13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V11H0V13C0 13.5523 0.447715 14 1 14H15C15.5523 14 16 13.5523 16 13V11Z"
      fill="#047857"
    />
    <path d="M2.16962 6H13.8306L16 11H0L2.16962 6Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49771 6.5L0.762006 10.5H15.238L13.5025 6.5H2.49771ZM13.8306 6H2.16962L0 11H16L13.8306 6Z"
      fill="#047857"
    />
    <path
      d="M3.91388 4.34601C3.98977 3.85906 4.40912 3.5 4.90195 3.5H11.0986C11.5914 3.5 12.0108 3.85906 12.0867 4.34601L12.3204 5.84602C12.4149 6.45237 11.946 7 11.3324 7H4.66819C4.05451 7 3.58562 6.45237 3.68012 5.84601L3.91388 4.34601Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0986 4H4.90195C4.65554 4 4.44586 4.17953 4.40792 4.42301L4.17415 5.92301C4.1269 6.22618 4.36135 6.5 4.66819 6.5H11.3324C11.6392 6.5 11.8736 6.22618 11.8264 5.92301L11.5926 4.42301C11.5547 4.17953 11.345 4 11.0986 4ZM4.90195 3.5C4.40912 3.5 3.98977 3.85906 3.91388 4.34601L3.68012 5.84601C3.58562 6.45237 4.05451 7 4.66819 7H11.3324C11.946 7 12.4149 6.45237 12.3204 5.84602L12.0867 4.34601C12.0108 3.85906 11.5914 3.5 11.0986 3.5H4.90195Z"
      fill="#047857"
    />
  </svg>
);

export const BedUnavailableUnselected: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Bed Unavailable and unselected"
  >
    <path d="M2.5 13H3V15H2.5V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 13H2.5V15H3V13Z"
      fill="#6B7280"
    />
    <path d="M13 13H13.5V15H13V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13H13V15H13.5V13Z"
      fill="#6B7280"
    />
    <path
      d="M2 3.5C2 2.39543 2.89543 1.5 4 1.5H12C13.1046 1.5 14 2.39543 14 3.5V6.5H2V3.5Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H4C3.17157 2 2.5 2.67157 2.5 3.5V6H13.5V3.5C13.5 2.67157 12.8284 2 12 2ZM4 1.5C2.89543 1.5 2 2.39543 2 3.5V6.5H14V3.5C14 2.39543 13.1046 1.5 12 1.5H4Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H4C3.17157 2 2.5 2.67157 2.5 3.5V6H13.5V3.5C13.5 2.67157 12.8284 2 12 2ZM4 1.5C2.89543 1.5 2 2.39543 2 3.5V6.5H14V3.5C14 2.39543 13.1046 1.5 12 1.5H4Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H4C3.17157 2 2.5 2.67157 2.5 3.5V6H13.5V3.5C13.5 2.67157 12.8284 2 12 2ZM4 1.5C2.89543 1.5 2 2.39543 2 3.5V6.5H14V3.5C14 2.39543 13.1046 1.5 12 1.5H4Z"
      fill="#6B7280"
    />
    <path
      d="M0 11H16V13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13V11Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 11H15.5V13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V11H0V13C0 13.5523 0.447715 14 1 14H15C15.5523 14 16 13.5523 16 13V11Z"
      fill="#6B7280"
    />
    <path d="M2.16962 6H13.8306L16 11H0L2.16962 6Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49771 6.5L0.762006 10.5H15.238L13.5025 6.5H2.49771ZM13.8306 6H2.16962L0 11H16L13.8306 6Z"
      fill="#6B7280"
    />
    <path
      d="M3.91364 4.34601C3.98953 3.85906 4.40888 3.5 4.90171 3.5H11.0983C11.5912 3.5 12.0105 3.85906 12.0864 4.34601L12.3202 5.84602C12.4147 6.45237 11.9458 7 11.3321 7H4.66794C4.05427 7 3.58537 6.45237 3.67987 5.84601L3.91364 4.34601Z"
      fill="#F3F4F6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0983 4H4.90171C4.65529 4 4.44562 4.17953 4.40767 4.42301L4.17391 5.92301C4.12666 6.22618 4.36111 6.5 4.66794 6.5H11.3321C11.639 6.5 11.8734 6.22618 11.8262 5.92301L11.5924 4.42301C11.5544 4.17953 11.3448 4 11.0983 4ZM4.90171 3.5C4.40888 3.5 3.98953 3.85906 3.91364 4.34601L3.67987 5.84601C3.58537 6.45237 4.05427 7 4.66794 7H11.3321C11.9458 7 12.4147 6.45237 12.3202 5.84602L12.0864 4.34601C12.0105 3.85906 11.5912 3.5 11.0983 3.5H4.90171Z"
      fill="#6B7280"
    />
    <path
      d="M9.90371 4.89522C9.90371 5.90512 9.08503 6.7238 8.07515 6.7238C7.06526 6.7238 6.24658 5.90512 6.24658 4.89522C6.24658 3.88533 7.06526 3.06665 8.07515 3.06665C9.08503 3.06665 9.90371 3.88533 9.90371 4.89522Z"
      fill="#9CA3AF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.07515 3.31665C7.20333 3.31665 6.49658 4.0234 6.49658 4.89522C6.49658 5.76705 7.20333 6.4738 8.07515 6.4738C8.94696 6.4738 9.65371 5.76705 9.65371 4.89522C9.65371 4.0234 8.94696 3.31665 8.07515 3.31665ZM5.99658 4.89522C5.99658 3.74726 6.92719 2.81665 8.07515 2.81665C9.22311 2.81665 10.1537 3.74726 10.1537 4.89522C10.1537 6.04319 9.22311 6.9738 8.07515 6.9738C6.92719 6.9738 5.99658 6.04319 5.99658 4.89522Z"
      fill="#6B7280"
    />
    <path
      d="M8.07634 6.72363C6.56151 6.72363 5.3335 7.95165 5.3335 9.46649H10.8192C10.8192 7.95165 9.59117 6.72363 8.07634 6.72363Z"
      fill="#9CA3AF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.59588 9.13015H10.5568C10.4314 7.96786 9.36872 7.06021 8.07634 7.06021C6.78396 7.06021 5.72128 7.96786 5.59588 9.13015ZM5.0835 9.36087C5.0835 7.8354 6.42344 6.59875 8.07634 6.59875C9.72924 6.59875 11.0692 7.8354 11.0692 9.36087V9.5916H5.0835V9.36087Z"
      fill="#6B7280"
    />
    <path d="M1.08398 8.5H14.916L16 11H0L1.08398 8.5Z" fill="#F3F4F6" />
    <path d="M1.08398 8.5H14.916L16 11H0L1.08398 8.5Z" fill="#F3F4F6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.41217 9L0.761775 10.5H15.2382L14.5878 9H1.41217ZM14.916 8.5H1.08398L0 11H16L14.916 8.5Z"
      fill="#6B7280"
    />
  </svg>
);

export const BedAvailableSelected: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Bed Available and selected"
  >
    <path d="M2.5 13H3V15H2.5V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 13H2.5V15H3V13Z"
      fill="#047857"
    />
    <path d="M13 13H13.5V15H13V13Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13H13V15H13.5V13Z"
      fill="#047857"
    />
    <path
      d="M2 3.5C2 2.39543 2.89543 1.5 4 1.5H12C13.1046 1.5 14 2.39543 14 3.5V6.5H2V3.5Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H4C3.17157 2 2.5 2.67157 2.5 3.5V6H13.5V3.5C13.5 2.67157 12.8284 2 12 2ZM4 1.5C2.89543 1.5 2 2.39543 2 3.5V6.5H14V3.5C14 2.39543 13.1046 1.5 12 1.5H4Z"
      fill="#047857"
    />
    <path
      d="M0 11H16V13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13V11Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 11H15.5V13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V11H0V13C0 13.5523 0.447715 14 1 14H15C15.5523 14 16 13.5523 16 13V11Z"
      fill="#047857"
    />
    <path d="M2.16962 6H13.8306L16 11H0L2.16962 6Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49771 6.5L0.762006 10.5H15.238L13.5025 6.5H2.49771ZM13.8306 6H2.16962L0 11H16L13.8306 6Z"
      fill="#047857"
    />
    <path d="M1.08398 8.5H14.916L16 11H0L1.08398 8.5Z" fill="#10B981" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.41217 9L0.761775 10.5H15.2382L14.5878 9H1.41217ZM14.916 8.5H1.08398L0 11H16L14.916 8.5Z"
      fill="#047857"
    />
    <path
      d="M3.91364 4.34601C3.98953 3.85906 4.40888 3.5 4.90171 3.5H11.0983C11.5912 3.5 12.0105 3.85906 12.0864 4.34601L12.3202 5.84602C12.4147 6.45237 11.9458 7 11.3321 7H4.66794C4.05427 7 3.58537 6.45237 3.67987 5.84601L3.91364 4.34601Z"
      fill="#10B981"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0983 4H4.90171C4.65529 4 4.44562 4.17953 4.40767 4.42301L4.17391 5.92301C4.12666 6.22618 4.36111 6.5 4.66794 6.5H11.3321C11.639 6.5 11.8734 6.22618 11.8262 5.92301L11.5924 4.42301C11.5544 4.17953 11.3448 4 11.0983 4ZM4.90171 3.5C4.40888 3.5 3.98953 3.85906 3.91364 4.34601L3.67987 5.84601C3.58537 6.45237 4.05427 7 4.66794 7H11.3321C11.9458 7 12.4147 6.45237 12.3202 5.84602L12.0864 4.34601C12.0105 3.85906 11.5912 3.5 11.0983 3.5H4.90171Z"
      fill="#047857"
    />
  </svg>
);

export const BedUnavailableSelected: React.FC<IconProps> = ({
  className = "size-4",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Bed Unavailable and selected"
  >
    <path d="M2.5 12.5H3V14.5H2.5V12.5Z" fill="white" />
    <path d="M3 12.5V14.5H2.5V12.5H3Z" fill="#6B7280" />
    <path d="M13 12.5H13.5V14.5H13V12.5Z" fill="white" />
    <path d="M13.5 12.5V14.5H13V12.5H13.5Z" fill="#047857" />
    <path
      d="M0 10.5H16V12.5C16 13.0523 15.5523 13.5 15 13.5H1C0.447715 13.5 0 13.0523 0 12.5V10.5Z"
      fill="white"
    />
    <path
      d="M0.5 12.5C0.5 12.7761 0.723858 13 1 13H15C15.2761 13 15.5 12.7761 15.5 12.5V10.5H16V12.5C16 13.0523 15.5523 13.5 15 13.5H1C0.447715 13.5 1.61067e-08 13.0523 0 12.5V10.5H0.5V12.5Z"
      fill="#6B7280"
    />
    <path
      d="M8 10.5H16V12.5C16 13.0523 15.5523 13.5 15 13.5H9C8.44772 13.5 8 13.0523 8 12.5V10.5Z"
      fill="white"
    />
    <path
      d="M8.5 13L8 13.5V10.5H8.5V13ZM16 12.5C16 13.0523 15.5523 13.5 15 13.5H8L8.5 13H15C15.2761 13 15.5 12.7761 15.5 12.5V10.5H16V12.5Z"
      fill="#047857"
    />
    <path d="M7.5 1H12C13.1046 1 14 1.89543 14 3V6H7.5V1Z" fill="white" />
    <path
      d="M13.5 3C13.5 2.17157 12.8284 1.5 12 1.5H8V5.5H13.5V3ZM14 6H7.5V1H12C13.1046 1 14 1.89543 14 3V6Z"
      fill="#047857"
    />
    <path
      d="M2 3C2 1.89543 2.89543 1 4 1H12C13.1046 1 14 1.89543 14 3V6H2V3Z"
      fill="white"
    />
    <path
      d="M13.5 3C13.5 2.19745 12.8697 1.54211 12.0771 1.50195L12 1.5H4C3.17157 1.5 2.5 2.17157 2.5 3V5.5H13.5V3ZM14 6H2V3C2 1.89543 2.89543 1 4 1H12L12.103 1.00244C13.1597 1.05606 14 1.92998 14 3V6Z"
      fill="#6B7280"
    />
    <path d="M2.16962 5.5H13.8306L16 10.5H0L2.16962 5.5Z" fill="white" />
    <path
      d="M16 10.5H0L2.16943 5.5H13.8306L16 10.5ZM0.761719 10H15.2383L13.5024 6H2.49805L0.761719 10Z"
      fill="#6B7280"
    />
    <path d="M8 5.5H13.8306L16 10.5H8V5.5Z" fill="white" />
    <path
      d="M16 10.5H8V5.5H13.8306L16 10.5ZM8.5 10H15.2383L13.5024 6H8.5V10Z"
      fill="#047857"
    />
    <path
      d="M3.91315 3.84601C3.98904 3.35906 4.40839 3 4.90122 3H11.0979C11.5907 3 12.01 3.35906 12.0859 3.84601L12.3197 5.34602C12.4142 5.95237 11.9453 6.5 11.3316 6.5H4.66746C4.05378 6.5 3.58489 5.95237 3.67938 5.34601L3.91315 3.84601Z"
      fill="#F3F4F6"
    />
    <path
      d="M11.0978 3C11.5907 3 12.0102 3.35924 12.0861 3.84619L12.32 5.34619C12.4085 5.91458 12.0018 6.43129 11.445 6.49365L11.3317 6.5V6C11.6386 6 11.8731 5.72603 11.8259 5.42285L11.592 3.92285C11.554 3.67946 11.3442 3.5 11.0978 3.5H4.90156C4.6552 3.5 4.44543 3.67946 4.40742 3.92285L4.17353 5.42285C4.12628 5.72603 4.36084 6 4.66767 6V6.5L4.55439 6.49365C4.03471 6.43544 3.64572 5.98142 3.66816 5.45898L3.67939 5.34619L3.91328 3.84619C3.98441 3.38973 4.35741 3.04569 4.80976 3.00439L4.90156 3H11.0978ZM11.3317 6V6.5H4.66767V6H11.3317Z"
      fill="#6B7280"
    />
    <path
      d="M12.3202 5.34602L12.0864 3.84601C12.0105 3.35906 11.5911 3 11.0983 3H8V6.5H11.3321C11.9458 6.5 12.4147 5.95237 12.3202 5.34602Z"
      fill="#10B981"
    />
    <path
      d="M11.0981 3C11.591 3 12.0105 3.35924 12.0864 3.84619L12.3203 5.34619C12.4147 5.95247 11.9456 6.5 11.332 6.5V6C11.6389 6 11.8734 5.72603 11.8262 5.42285L11.5923 3.92285C11.5543 3.67946 11.3445 3.5 11.0981 3.5H8.5V6H11.332V6.5H8V3H11.0981Z"
      fill="#047857"
    />
    <path
      d="M9.90395 4.39571C9.90395 5.4056 9.08528 6.22428 8.07539 6.22428C7.0655 6.22428 6.24683 5.4056 6.24683 4.39571C6.24683 3.38582 7.0655 2.56714 8.07539 2.56714C9.08528 2.56714 9.90395 3.38582 9.90395 4.39571Z"
      fill="#9CA3AF"
    />
    <path
      d="M9.65405 4.39575C9.65405 3.52395 8.94723 2.81717 8.07544 2.81714C7.20362 2.81714 6.49683 3.52393 6.49683 4.39575C6.49685 5.26756 7.20364 5.97437 8.07544 5.97437C8.94722 5.97434 9.65403 5.26754 9.65405 4.39575ZM10.1541 4.39575C10.154 5.54368 9.22336 6.47434 8.07544 6.47437C6.92749 6.47437 5.99685 5.5437 5.99683 4.39575C5.99683 3.24779 6.92748 2.31714 8.07544 2.31714C9.22338 2.31717 10.1541 3.24781 10.1541 4.39575Z"
      fill="#6B7280"
    />
    <path
      d="M8.07659 6.22339C6.56175 6.22339 5.33374 7.45141 5.33374 8.96625H10.8194C10.8194 7.45141 9.59142 6.22339 8.07659 6.22339Z"
      fill="#9CA3AF"
    />
    <path
      d="M8.07642 5.97339C9.72926 5.97339 11.0695 7.31324 11.0696 8.96606V9.21606H5.08374V8.96606C5.08384 7.3133 6.42365 5.97348 8.07642 5.97339ZM8.07642 6.47339C6.78417 6.47347 5.72142 7.45682 5.59595 8.71606H10.5569C10.4314 7.45678 9.36873 6.47339 8.07642 6.47339Z"
      fill="#6B7280"
    />
    <path d="M1.08398 8H14.916L16 10.5H0L1.08398 8Z" fill="#F3F4F6" />
    <path
      d="M16 10.5H0L1.08398 8H14.916L16 10.5ZM0.76123 10H15.2388L14.5884 8.5H1.41162L0.76123 10Z"
      fill="#6B7280"
    />
    <path d="M16 10.5L14.916 8H8V10.5H16Z" fill="#10B981" />
    <path
      d="M14.916 8L16 10.5H8V8H14.916ZM8.5 10H15.2388L14.5884 8.5H8.5V10Z"
      fill="#047857"
    />
  </svg>
);

export const TestTubeIcon: React.FC<IconProps> = ({ className = "size-4" }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="TestTube Icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.07971 18.2218L18.2218 4.07971L26 11.8579L11.8579 26L4.07971 18.2218ZM6.90814 18.2218L11.8579 23.1716L23.1716 11.8579L18.2218 6.90814L6.90814 18.2218Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8579 23.1716L23.1716 11.8579L40.8493 29.5356C43.9735 32.6597 43.9735 37.7251 40.8493 40.8493C37.7251 43.9735 32.6597 43.9735 29.5356 40.8493L11.8579 23.1716ZM14.6863 23.1716L30.9498 39.435C33.2929 41.7782 37.0919 41.7782 39.435 39.435C41.7782 37.0919 41.7782 33.2929 39.435 30.9498L23.1716 14.6863L14.6863 23.1716Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6361 23.8787L27.4142 16.1005L39.435 28.1213L31.6569 35.8995L19.6361 23.8787ZM22.4645 23.8787L31.6569 33.0711L36.6066 28.1213L27.4142 18.929L22.4645 23.8787Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32235 13.9792L15.747 21.4038L14.3328 22.818L6.90814 15.3934L8.32235 13.9792Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8579 10.4437L19.2825 17.8683L17.8683 19.2825L10.4437 11.8579L11.8579 10.4437Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3934 6.90814L22.818 14.3328L21.4038 15.747L13.9792 8.32235L15.3934 6.90814Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.6023 32.2314C24.9634 32.8702 24.5738 33.4408 24.4738 33.7409L22.5765 33.1084C22.83 32.3478 23.5011 31.5042 24.1881 30.8172C24.9001 30.1052 25.7812 29.4108 26.6134 28.9947L27.5079 30.7835C26.9259 31.0745 26.2161 31.6176 25.6023 32.2314Z"
      fill="currentColor"
    />
  </svg>
);
